<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control
    [floatLabel]="true"
    [underlineInputStyle]="true"
    label="Imię i nazwisko">
    <input
      [formControl]="form.controls.dignity"
      pInputText />
  </app-form-control>

  <app-form-control
    [floatLabel]="true"
    [underlineInputStyle]="true"
    label="Adres e-mail">
    <input
      [formControl]="form.controls.email"
      appPrimengInputText
      pInputText />
  </app-form-control>

  <app-form-control
    [floatLabel]="true"
    [underlineInputStyle]="true"
    label="Numer telefonu">
    <input
      [formControl]="form.controls.phone"
      appPrimengInputText
      pInputText />
  </app-form-control>

  <app-form-control
    [floatLabel]="true"
    [underlineInputStyle]="true"
    label="Powód kontaktu">
    <p-select
      [formControl]="form.controls.type"
      [options]="valueOrDefault(issueTypeSelectItems$ | async, [])"
      appPrimengSelect
      [fluid]="true" />
  </app-form-control>

  @if (complaintFormGroupAvailability$ | async) {
    <ng-container [formGroup]="form.controls.complaint">
      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Powód reklamacji">
        <p-multi-select
          [fluid]="true"
          [formControl]="form.controls.complaint.controls.reasons"
          [options]="valueOrDefault(issueComplaintTypeSelectItems$ | async, [])"
          appPrimengMultiselect />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Numer zamówienia">
        <input
          [formControl]="form.controls.complaint.controls.orderNumber"
          appPrimengInputText
          pInputText />
      </app-form-control>

      <div class="mb-4">
        Jeśli możesz, dołącz zdjęcie uszkodzonych produktów/pudełka do
        zgłoszenia reklamacji.
      </div>

      <app-form-control>
        <app-public-shop-multimedia-upload-control
          [maxFileSize]="maxFileSize"
          [multi]="true"
          [maxNumberOfFiles]="maxNumberOfFiles"
          [formControl]="form.controls.complaint.controls.fileIds" />
      </app-form-control>
    </ng-container>
  }

  <app-form-control
    [floatLabel]="true"
    [underlineInputStyle]="true"
    label="Treść wiadomości">
    <textarea
      [formControl]="form.controls.message"
      [rows]="5"
      appPrimengTextarea
      pTextarea></textarea>
  </app-form-control>

  <app-form-control inputId="77980244-0b50-49ec-98d8-a2442111e501">
    <app-checkbox-with-label
      inputId="77980244-0b50-49ec-98d8-a2442111e501"
      type="short">
      <span label>Wyrażam zgodę na przetwarzanie moich danych osobowych.</span>
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.acceptRules" />
    </app-checkbox-with-label>
  </app-form-control>

  <div class="flex justify-center">
    <app-form-control>
      <app-re-captcha [formControl]="form.controls.recaptcha" />
    </app-form-control>
  </div>

  <div>
    <p-button
      [disabled]="form.invalid"
      [fluid]="true"
      appPrimengButton
      label="Wyślij"
      type="submit" />
  </div>
</form>
